import {
  CREATE_FACTORING_PROFILE_REQUEST,
  CREATE_FACTORING_PROFILE_SUCCESS,
  CREATE_FACTORING_PROFILE_FAILURE
} from "../types";

const createFactoringProfile = (state, { type, payload }) => {
  switch (type) {
    case CREATE_FACTORING_PROFILE_REQUEST:
      return {
        ...state,
        loading: true
      };
    case CREATE_FACTORING_PROFILE_SUCCESS:
      return {
        ...state,
        loading: false,
        factoringProfileSuccess: payload
      };
    case CREATE_FACTORING_PROFILE_FAILURE:
      return {
        ...state,
        loading: false
      };
    default:
      return {
        ...state
      };
  }
};

export default createFactoringProfile;
